export const PRODUCT_10001_URL_MAP = {
  adultMember: `10001.actionType.url.1`,
  adultNonMember: `10001.actionType.url.2`,
  minorMember: `10001.actionType.url.3`,
  minorNonMember:`10001.actionType.url.4`,
}